/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { FormsCustomFormSetupFlowArgs, Tabs } from 'cio/components/forms/custom/setup-flow';

// using "type" instead of "interface" because of lint rule for no-empty-interface
type FormsCustomFormModalArgs = Omit<
  FormsCustomFormSetupFlowArgs,
  'onTabChange' | 'onConnectedFormChange' | 'isInModal' | 'onShowFormProvidersModal'
>;

export default class FormsCustomModal extends Component<FormsCustomFormModalArgs> {
  readonly tabs = Tabs;
  @tracked showFormProvidersModal = false;
  @tracked currentTab: Tabs | null = null;
  @tracked connectedForm = false;

  @action
  onClose() {
    if (this.connectedForm) {
      this.args.onConnectFormAndClose?.(this.args.form);
    }
    if (!this.args.form.get('isNew')) {
      this.args.form.rollbackAttributes();
    }
    this.args.onClose();
  }

  @action
  changeShowFormProvidersModal(value: boolean) {
    this.showFormProvidersModal = value;
  }

  @action
  onTabChange(value: Tabs) {
    this.currentTab = value;
  }

  @action
  onConnectedFormChange(value: boolean) {
    this.connectedForm = value;
  }
}
